import { ColumnDescription } from "react-bootstrap-table-next";
import Table from "../../../../../Components/Table";
import { formatMoneyReais } from "../../../../../Tools/FormatTools";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useRegistrarAcordoSiengeContext } from "..";
import {
    faEdit,
    faStepForward,
    faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";
import { IComponentModal } from "../../../../../Components/Modais/IModalComponent";
import ModalComponent from "../../../../../Components/Modais";
import EditarAdicionarCondicoesPagamento from "./EditarAdicionarCondicoesPagamento";
import { IParcelaBoletosResponseSienge } from "../../../../../Interfaces/Cobranca/ParcelasAbertas/ParcelasAbertas";
import Swal from "sweetalert2";
import moment from "moment";

export default function CondicoesPagamento() {
    const {
        goToStep,
        lstSelecionados,
        lstSelecionadosParcelasGeradas,
        setLstSelecionadosParcelasGeradas,
        parcelaReq,
        setParcelaReq,
    } = useRegistrarAcordoSiengeContext();

    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();

    const columns: Array<ColumnDescription<IParcelaBoletosResponseSienge>> = [
        {
            dataField: "Descricao_par",
            text: "Tipo condição",
            classes: "p-3 ws-nowrap align-middle text-center",
            formatter: (c, row) => {
                const data = new Date(row.Data_Prc);
                return (
                    <span
                        className={
                            data.getTime() < Date.now() ? "text-danger" : ""
                        }
                    >
                        {c}
                    </span>
                );
            },
            headerAlign: "center",
        },
        {
            dataField: "ValorReaj",
            text: "Valor total",
            formatter: (c, row) => {
                const data = new Date(row.Data_Prc);
                return (
                    <span
                        className={
                            data.getTime() < Date.now() ? "text-danger" : ""
                        }
                    >
                        {formatMoneyReais(c)}
                    </span>
                );
            },
            classes: "p-3 ws-nowrap align-middle text-center",
            align: "center",
            headerAlign: "center",
        },
        {
            dataField: "quantidadePrc",
            text: "Quantidade",
            formatter: (c, row) => {
                const data = new Date(row.Data_Prc);
                return (
                    <span
                        className={
                            data.getTime() < Date.now() ? "text-danger" : ""
                        }
                    >
                        {c}
                    </span>
                );
            },
            classes: "p-3 ws-nowrap align-middle text-center",
            align: "center",
            headerAlign: "center",
        },
        {
            dataField: "IdxReaj_Prc",
            text: "Indexador",
            formatter: (c, row) => {
                const data = new Date(row.Data_Prc);
                return (
                    <span
                        className={`${
                            data.getTime() < Date.now() ? "text-danger" : ""
                        } mt-2`}
                    >
                        {c}
                    </span>
                );
            },
            classes: "p-3 ws-nowrap align-middle text-center",
            align: "center",
            headerAlign: "center",
        },
        {
            dataField: "Data_Prc",
            text: "Data do 1º vencimento",
            formatter: (c, row) => {
                const data = new Date(row.Data_Prc);
                return (
                    <span
                        className={`${
                            data.getTime() < Date.now() ? "text-danger" : ""
                        } mt-2`}
                    >
                        {c ? moment(c).format("DD/MM/YYYY") : "-"}
                    </span>
                );
            },
            classes: "p-3 ws-nowrap align-middle text-center",
            align: "center",
            headerAlign: "center",
        },
        {
            dataField: "DtBase_Correcao",
            text: "Data base",
            formatter: (c, row) => {
                const data = new Date(row.Data_Prc);
                return (
                    <span
                        className={`${
                            data.getTime() < Date.now() ? "text-danger" : ""
                        } mt-2`}
                    >
                        {c ? moment(c).format("DD/MM/YYYY") : "-"}
                    </span>
                );
            },
            classes: "p-3 ws-nowrap align-middle text-center",
            align: "center",
            headerAlign: "center",
        },
        {
            dataField: "dataBaseParaJurosPrc",
            text: "Data base juros",
            formatter: (c, row) => {
                const data = new Date(row.Data_Prc);
                return (
                    <span
                        className={`${
                            data.getTime() < Date.now() ? "text-danger" : ""
                        } mt-2`}
                    >
                        {c ? moment(c).format("DD/MM/YYYY") : "-"}
                    </span>
                );
            },
            classes: "p-3 ws-nowrap align-middle text-center",
            align: "center",
            headerAlign: "center",
        },
        {
            dataField: "",
            text: "Ação",
            formatter: (c, row, _, setEdit) => (
                <div className="d-flex justify-content-center align-items-center p-3 g-2">
                    <button
                        className="btn btn-icon btn-outline-primary"
                        onClick={() => {
                            setModal({
                                headerComponent: "Condições Pagamento",
                                Component: () => (
                                    <EditarAdicionarCondicoesPagamento
                                        setShow={setShow}
                                        row={row}
                                    />
                                ),
                                noFooter: true,
                                size: "lg",
                                scrollable: true,
                            });
                            setShow(true);
                        }}
                    >
                        <FontAwesomeIcon icon={faEdit} />
                    </button>
                    <button
                        className="btn btn-icon btn-outline-danger"
                        onClick={() => {
                            Swal.fire({
                                title: "Deseja deletar essa condição de pagamento?",
                                icon: "info",
                                buttonsStyling: false,
                                confirmButtonText:
                                    "<i class='la la-check'></i> Sim!",
                                showCancelButton: true,
                                cancelButtonText:
                                    "<i class='la la-thumbs-down'></i> Não",
                                customClass: {
                                    confirmButton: "btn btn-outline-success",
                                    cancelButton: "btn btn-default",
                                },
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    const indexToDelete =
                                        lstSelecionadosParcelasGeradas?.findIndex(
                                            (item) =>
                                                item.NumParc_Prc ===
                                                row.NumParc_Prc
                                        );

                                    if (indexToDelete !== -1) {
                                        const updatedList = [
                                            ...(lstSelecionadosParcelasGeradas?.slice(
                                                0,
                                                indexToDelete
                                            ) ?? []),
                                            ...(lstSelecionadosParcelasGeradas?.slice(
                                                (indexToDelete ?? 0) + 1
                                            ) ?? []),
                                        ];

                                        setLstSelecionadosParcelasGeradas(
                                            updatedList
                                        );
                                    }
                                }
                            });
                        }}
                    >
                        <FontAwesomeIcon icon={faTrash} />
                    </button>
                </div>
            ),
            classes: "p-3 ws-nowrap align-middle text-center",
            align: "center",
            headerAlign: "center",
        },
    ];

    return (
        <>
            <h3>Informações da parcela selecionada:</h3>
            <div className="row">
                <div className="col-12 col-sm-6">
                    <label className="text-muted mb-0">
                        Data de reparcelamento
                    </label>
                    <input
                        type="date"
                        className={`form-control px-0 p-2`}
                        defaultValue={parcelaReq.DT_CALCULO}
                        onBlur={(e) => {
                            const DT_CALCULO = e.target.value;
                            if (
                                DT_CALCULO &&
                                DT_CALCULO !== parcelaReq.DT_CALCULO
                            ) {
                                setParcelaReq({
                                    DT_CALCULO,
                                });
                            }
                        }}
                    />
                </div>
                <div className="col-12 col-sm-6">
                    <div className="d-flex flex-column align-items-center justify-content-center">
                        <h4>Valor Total Parcelas:</h4>
                        <span className="font-size-lg text-muted font-weight-bold">
                            {formatMoneyReais(
                                lstSelecionados?.reduce(
                                    (sum, parcela) => sum + parcela.ValorReaj,
                                    0.0
                                ) ?? 0
                            )}
                        </span>
                    </div>
                </div>
            </div>
            <div className="d-flex justify-content-end">
                <button
                    className="btn btn-success"
                    onClick={() => {
                        setModal({
                            headerComponent: "Condições Pagamento",
                            Component: () => (
                                <EditarAdicionarCondicoesPagamento
                                    setShow={setShow}
                                />
                            ),
                            noFooter: true,
                            size: "lg",
                            scrollable: true,
                        });
                        setShow(true);
                    }}
                >
                    Adicionar
                </button>
            </div>
            <div className="mt-5">
                <Table
                    keyField="id"
                    data={lstSelecionadosParcelasGeradas ?? []}
                    columns={columns}
                    noSearch
                    striped
                />
            </div>
            <div className="d-flex justify-content-end mt-5">
                <button
                    className="btn btn-outline-danger mr-2"
                    onClick={() => goToStep("selecParcelas")}
                >
                    Anterior
                </button>
                <button
                    className="btn btn-primary"
                    onClick={() => {
                        goToStep("simularParcela");
                    }}
                    disabled={
                        !lstSelecionadosParcelasGeradas ||
                        lstSelecionadosParcelasGeradas?.length === 0
                    }
                >
                    Próximo
                    <FontAwesomeIcon className="ml-2" icon={faStepForward} />
                </button>
            </div>
            <ModalComponent
                ModalComponent={modal}
                show={show}
                setShow={setShow}
            />
        </>
    );
}
